import { KuxFilteredCategoriesDTO } from '@kaltura-ott/tvpil';
import { useMemo } from 'react';

import { useCategoryTreeItem } from '../categoryTree';
import { tvpil } from '../compat/tvpil';
import { RhinoImageRatio } from '../image';

type UsePersonalLineupSettingsProps = {
  referenceId: string;
};

export type PersonalLineupSettings = {
  branding: KuxFilteredCategoriesDTO['uiDesignElements'];
  channelIconType: number | undefined;
  channelIconRatio: RhinoImageRatio;
};

export function usePersonalLineupSettings({
  referenceId,
}: UsePersonalLineupSettingsProps): PersonalLineupSettings | undefined {
  const category = useCategoryTreeItem(referenceId);

  const settings = useMemo(() => {
    if (!category) {
      return;
    }

    return {
      branding: category.uiDesignElements,
      channelIconRatio: '16x9' as RhinoImageRatio,
      channelIconType: tvpil.getTypeByTypeName('16x9')?.id,
    };
  }, [category]);

  return settings;
}
